const holesMixin = {
	data: function () {
		return {
			showDistanceFromEdge: true,
			disableCounterSunk: true,
			product: {
				holes: this.defaultDrilledHoles(),
			},
		};
	},
	methods: {
		defaultDrilledHoles: function () {
			return {
				hasDrilledHoles: false,
				holeSize: 0,
				distanceFromEdge: 0,
				countersunk: false,
				placement: [],
			};
		},
		toggleDrillHole: function (event) {
			const vm = this;
			const holes = vm.product.holes.placement;
			const value = event.target.value;
			const holeArrayPosition = holes.indexOf(value);

			//add item
			if (holeArrayPosition === -1) {
				holes.push(value);
				holes.sort();
			} else {
				//delete item
				holes.splice(holeArrayPosition, 1);
			}

			if (holes.length == 1 && holes[0] == 'center') {
				vm.showDistanceFromEdge = false;
				vm.product.holes.distanceFromEdge = vm.defaultDrilledHoles.distanceFromEdge;
				document.getElementById('drill-hole-distance').classList.remove('is-invalid');
			} else {
				if (vm.showDistanceFromEdge == false) {
					vm.product.holes.distanceFromEdge = 0;
				}
				vm.showDistanceFromEdge = true;
			}

			if (holes.length > 0) {
				const holes = document.querySelectorAll('.drill-hole-wrapper input[type=checkbox]');
				holes.forEach(function (hole) {
					hole.classList.remove('is-invalid');
					hole.parentElement.classList.remove('is-invalid');
				});
			}

			setTimeout(function () {
				if (!document.querySelector('.is-invalid')) {
					vm.updateProductPrice();
				}
			}, 100);

			const errorMessages = document.querySelectorAll("#drilled-holes [id$='-error']");

			vm.clearServerSideErrors(errorMessages);

			this.globalValidation();
		},
		toggleCounterSunk: function (value) {
			const vm = this;
			vm.product.holes.countersunk = value;

			this.globalValidation();
			this.updateProductPrice();
		},
	},
	watch: {
		'product.holes.holeSize': function (holeSize) {
			const vm = this;

			if (holeSize <= 10) {
				vm.disableCounterSunk = false;
			} else {
				vm.product.holes.countersunk = false;
				vm.disableCounterSunk = true;
				vm.$refs['countersink-2-label'].click();
			}
		},
	},
};
